export const stateIdToAbbr = {
  "01": "Alabama",
  "02": "Alaska",
  "04": "Arizona",
  "05": "Arkansas",
  "06": "California",
  "08": "Colorado",
  "09": "Connecticut",
  10: "Delaware",
  12: "Florida",
  13: "Georgia",
  15: "Hawaii",
  16: "Idaho",
  17: "Illinois",
  18: "Indiana",
  19: "Iowa",
  20: "Kansas",
  21: "Kentucky",
  22: "Louisiana",
  23: "Maine",
  24: "Maryland",
  25: "Massachusetts",
  26: "Michigan",
  27: "Minnesota",
  28: "Mississippi",
  29: "Missouri",
  30: "Montana",
  31: "Nebraska",
  32: "Nevada",
  33: "New Hampshire",
  34: "New Jersey",
  35: "New Mexico",
  36: "New York",
  37: "North Carolina",
  38: "North Dakota",
  39: "Ohio",
  40: "Oklahoma",
  41: "Oregon",
  42: "Pennsylvania",
  44: "Rhode Island",
  45: "South Carolina",
  46: "South Dakota",
  47: "Tennessee",
  48: "Texas",
  49: "Utah",
  50: "Vermont",
  51: "Virginia",
  53: "Washington",
  54: "West Virginia",
  55: "Wisconsin",
  56: "Wyoming",
};

export const revenueData = {
  Alabama: 150000,
  Alaska: 80000,
  Arizona: 350000,
  Arkansas: 200000,
  California: 1200000,
  Colorado: 400000,
  Connecticut: 300000,
  Delaware: 100000,
  Florida: 700000,
  Georgia: 500000,
  Hawaii: 90000,
  Idaho: 120000,
  Illinois: 650000,
  Indiana: 250000,
  Iowa: 150000,
  Kansas: 160000,
  Kentucky: 180000,
  Louisiana: 220000,
  Maine: 110000,
  Maryland: 340000,
  Massachusetts: 420000,
  Michigan: 500000,
  Minnesota: 310000,
  Mississippi: 140000,
  Missouri: 320000,
  Montana: 90000,
  Nebraska: 130000,
  Nevada: 230000,
  "New Hampshire": 125000,
  "New Jersey": 480000,
  "New Mexico": 140000,
  "New York": 850000,
  "North Carolina": 600000,
  "North Dakota": 75000,
  Ohio: 550000,
  Oklahoma: 210000,
  Oregon: 280000,
  Pennsylvania: 700000,
  "Rhode Island": 95000,
  "South Carolina": 300000,
  "South Dakota": 80000,
  Tennessee: 370000,
  Texas: 1500000,
  Utah: 250000,
  Vermont: 70000,
  Virginia: 520000,
  Washington: 450000,
  "West Virginia": 120000,
  Wisconsin: 290000,
  Wyoming: 60000,
};
